import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Registration from './pages/Registration';
import AdminDashboard from './pages/AdminDashboard';
import BuyerDashboard from './pages/BuyerDashboard';
import UserDashboard from './pages/UserDashboard';
import SuperuserDashboard from './pages/SuperuserDashboard';
import CertificateNamePage from './pages/CertificateNamePage';
import BuyerLaunchPanel from './pages/BuyerLaunchPanel';

// Import the new e-commerce pages
import ProductPage from './pages/ProductPage';
import PurchaseSuccessPage from './pages/PurchaseSuccessPage';
import PurchaseCancelPage from './pages/PurchaseCancelPage';

// Import the new component
import AcademicVerificationPanel from './pages/AcademicVerificationPanel';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/buyer" element={<BuyerDashboard />} />
        <Route path="/user" element={<UserDashboard />} />
        <Route path="/superuser" element={<SuperuserDashboard />} />
        <Route path="/certificate-name" element={<CertificateNamePage />} />
        
        {/* New e-commerce routes */}
        <Route path="/purchase" element={<ProductPage />} />
        <Route path="/purchase-success" element={<PurchaseSuccessPage />} />
        <Route path="/purchase-cancel" element={<PurchaseCancelPage />} />

        {/* Add the new route */}
        <Route path="/admin/academic-verification" element={<AcademicVerificationPanel />} />

	<Route path="/buyer/launch" element={<BuyerLaunchPanel />} />
      </Routes>
    </Router>
  );
}

export default App;